var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcApagadoMotorDesactivado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 192.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040006;}.cls-2{fill:#9e4502;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-apagado-motor-desactivado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_34",
    "data-name": 34
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.47,10.93v7.51H147.54V56.35H207.3A.69.69,0,0,1,208,57v48.84h27.32V81.11h8.88V147.2h-8.88V123H208.67v20.82a1.32,1.32,0,0,1-.4.95l-36.5,35.94a4.69,4.69,0,0,1-3.34,1.37H101.91a4.76,4.76,0,0,1-3.53-1.57L77.44,157.29l-3.26-3.6H57.89A6.67,6.67,0,0,1,51.23,147V123H19.81v30.39H10.93V84.7h8.88v30.39H51.23V92a6.67,6.67,0,0,1,6.66-6.66H73.58l3.26-3.7L97.77,58a4.78,4.78,0,0,1,3.57-1.61h37V18.44H112.7V10.93h59.77M177.08,0h-69a6.32,6.32,0,0,0-6.32,6.32V23.05a6.32,6.32,0,0,0,6.32,6.32h19.3V45.42h-26a15.69,15.69,0,0,0-11.76,5.31L68.65,74.45H57.89A17.59,17.59,0,0,0,40.3,92v12.12H30.74V79.57a5.81,5.81,0,0,0-5.81-5.8H5.81A5.81,5.81,0,0,0,0,79.57v78.9a5.81,5.81,0,0,0,5.81,5.8H24.93a5.81,5.81,0,0,0,5.81-5.8V133.88H40.3V147a17.58,17.58,0,0,0,17.59,17.58H69.33l20.94,23.18A15.71,15.71,0,0,0,101.91,193h66.52a15.68,15.68,0,0,0,11-4.51l36.5-35.94a12.29,12.29,0,0,0,3.66-8.74v-9.89h4.78v18a6.24,6.24,0,0,0,6.23,6.24h18.28a6.24,6.24,0,0,0,6.23-6.24V76.42a6.23,6.23,0,0,0-6.23-6.24H230.61a6.23,6.23,0,0,0-6.23,6.24V94.94h-5.46V57A11.61,11.61,0,0,0,207.3,45.42H158.47v-16h18.61a6.32,6.32,0,0,0,6.32-6.32V6.32A6.32,6.32,0,0,0,177.08,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.83,
    y: 92.68,
    width: 105.19,
    height: 47.03,
    rx: 23.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 167.57,
    cy: 116.19,
    r: 13.94
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApagadoMotorDesactivado);
export default __webpack_public_path__ + "static/media/ic-apagado-motor-desactivado.2353a8200d779e70003427d3ee723a3b.svg";
export { ForwardRef as ReactComponent };